const items = [
    {
        key: 'previewDate',
        title: 'Preview Date',
        description: 'Simulate how the website will appear on a specific date.',
        type: 'date',
    },
    {
        key: 'contentfulPreviewMode',
        title: 'Preview Mode',
        description: 'Enable preview mode to view unpublished (draft) content from Contentful.',
        type: 'switch',
    },
] as const;

const contentfulEnvironmentItem = {
    key: 'contentfulEnvironment',
    title: 'Contentful Environment',
    description: 'Choose which Contentful environment supplies site content.',
    type: 'select',
    options: [
        { value: undefined, label: 'Master' },
        { value: 'stage', label: 'Stage' },
    ],
} as const;

export function getItems(appEnvironment: string) {
    return appEnvironment === 'stage' ? [...items, contentfulEnvironmentItem] : items;
}
